import { queryOptions } from "@tanstack/react-query";
import { type ColumnFiltersState } from "@tanstack/react-table";
import { formatISO } from "date-fns";
import { useDates } from "../../../../dates/DatesContext";
import { useAppSelector } from "../../../../redux/hooks";
import { apiClient } from "../../../../zodios/client";
import { clientToServerFiltering } from "../../../../components/table/utils";

type Params = {
  filters?: ColumnFiltersState;
  search?: string;
  start?: Date;
  end?: Date;
  preStart?: Date;
  preEnd?: Date;
  group?: "day" | "week" | "month";
};

export const useGetV4CategoryReportByDate = () => {
  const marketPlace = useAppSelector((state) => state.marketPlace.marketPlace);
  const { start, end, group, preStart, preEnd } = useDates();
  return (params?: Params) => {
    const search = params?.search ? params.search.split(",") : [];
    return queryOptions({
      queryKey: [
        { entity: "V4CategoryReportByDate", marketPlace, params, dates: { start, end, preStart, preEnd, group } },
      ],
      queryFn: async () => {
        const res = await apiClient.getV4CategoryReportByDate({
          queries: {
            marketplace: marketPlace,
            start_date:
              params?.start ? formatISO(params.start, { representation: "date" }) : start.format("YYYY-MM-DD"),
            end_date: params?.end ? formatISO(params.end, { representation: "date" }) : end.format("YYYY-MM-DD"),
            start_date_previous:
              params?.preStart ? formatISO(params.preStart, { representation: "date" }) : preStart.format("YYYY-MM-DD"),
            end_date_previous:
              params?.preEnd ? formatISO(params.preEnd, { representation: "date" }) : preEnd.format("YYYY-MM-DD"),
            filters: clientToServerFiltering(params?.filters),
            date_group: params?.group ?? group,
            search,
          },
        });
        return res;
      },
    });
  };
};

export type CategoryReportByDateRow = Awaited<ReturnType<typeof apiClient.getV4CategoryReportByDate>>["data"][number];
